module.exports = __webpack_public_path__ + "static/media/bb.66bc0e8d.svg";